module.exports = __webpack_public_path__ + "static/media/caroline.c90f5313.jpg";